import { render } from "./WeatherStationBadge.vue?vue&type=template&id=41884e21&ts=true"
import script from "./WeatherStationBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeatherStationBadge.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/WeatherStation/WeatherStationBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41884e21"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41884e21', __exports__)) {
    console.log('reload')
    api.reload('41884e21', __exports__)
  }
  
  module.hot.accept("./WeatherStationBadge.vue?vue&type=template&id=41884e21&ts=true", () => {
    console.log('re-render')
    api.rerender('41884e21', render)
  })

}


export default __exports__